import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  ExpirationType,
  ExpirationTypeDetails,
  ProductType,
  ProductsService,
  QuickbooksCategory,
} from 'src/app/services/products.service';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss'],
})
export class AddProductComponent {
  @ViewChild('confirmDialog') confirmDialog!: ElementRef<HTMLDialogElement>;

  title = '';
  description = '';
  type?: ProductType;
  expirationType?: ExpirationType;
  code = '';
  varianceCode = '';
  quickbooksCategory?: QuickbooksCategory;
  active = true;
  isService = false;
  standalone = false;
  requiresParent = false;

  creatingProduct = false;
  productCreated = false;
  errorCreatingProduct = '';

  productTypes = this.productsService.productTypes;
  quickbooksCategories?: QuickbooksCategory[];
  fetchingQuickbooksCategories = false;
  errorFetchingQuickbooksCategories = '';

  expirationTypes: ExpirationType[] = [
    'desktop',
    'annual',
    'force_extension',
    'physical',
    'transactional',
  ];

  ExpirationTypeDetails = ExpirationTypeDetails;

  constructor(private productsService: ProductsService) {}

  ngOnInit() {
    this.fetchQuickbooksCategories();
  }

  fetchQuickbooksCategories() {
    this.fetchingQuickbooksCategories = true;
    this.errorFetchingQuickbooksCategories = '';
    this.productsService.getQuickbooksCategories().subscribe({
      next: (response) => {
        this.fetchingQuickbooksCategories = false;
        this.quickbooksCategories = response;
      },
      error: (error) => {
        this.fetchingQuickbooksCategories = false;
        console.error(error);
        this.errorFetchingQuickbooksCategories = error;
      },
    });
  }

  openConfirmDialog() {
    if (!this.validateInputs()) {
      return;
    }

    this.confirmDialog.nativeElement.showModal();
  }

  validateInputs() {
    console.log('validateInputs', {
      active: this.active,
      type: this.type,
      is_service: this.isService,
      code: this.code,
      variance_code: this.varianceCode,
      standalone: this.standalone,
      description: this.description,
      requires_parent: this.requiresParent,
      quickbooks_category: this.quickbooksCategory,
      expiration_type: this.expirationType,
    });

    this.errorCreatingProduct = '';
    if (!this.type || this.type.trim() === '') {
      this.errorCreatingProduct = 'Please select a type';
      return false;
    }
    if (!this.description || this.description.trim() === '') {
      this.errorCreatingProduct = 'Please enter a description';
      return false;
    }
    if (!this.code || this.code.trim() === '') {
      this.errorCreatingProduct = 'Please enter a code';
      return false;
    }
    if (!this.quickbooksCategory) {
      this.errorCreatingProduct = 'Please select a Quickbooks category';
      return false;
    }
    if (!this.expirationType) {
      this.errorCreatingProduct = 'Please select an expiration type';
      return false;
    }
    return true;
  }

  createProduct() {
    this.closeConfirmDialog();
    this.creatingProduct = true;
    this.productCreated = false;
    this.errorCreatingProduct = '';

    if (!this.type || !this.quickbooksCategory || !this.expirationType) {
      this.errorCreatingProduct = 'Missing required fields';
      return;
    }

    this.productsService
      .createProduct({
        active: this.active,
        type: this.type!,
        is_service: this.isService,
        code: this.code,
        variance_code: this.varianceCode,
        standalone: this.standalone,
        title: this.title,
        description: this.description,
        requires_parent: this.requiresParent,
        quickbooks_category_id: this.quickbooksCategory!.id,
        expiration_type: this.expirationType!,
      })
      .subscribe({
        next: (response) => {
          console.log('response: ', response);
          this.creatingProduct = false;
          this.productCreated = true;
          this.errorCreatingProduct = '';
        },
        error: (error) => {
          console.error(error);
          this.creatingProduct = false;
          this.productCreated = false;
          this.errorCreatingProduct = error.message;
        },
      });
  }

  closeConfirmDialog() {
    this.confirmDialog.nativeElement.close();
  }
}
